import { render, staticRenderFns } from "./BussinessType.vue?vue&type=template&id=0f657cd6"
import script from "./BussinessType.vue?vue&type=script&lang=js"
export * from "./BussinessType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports